import React, { Component } from "react";
import ResponsiveTable from "./ResponsiveTable";
import GenericModal from "./GenericModal";
import LangContext from "../contextProvider/LangContext";
import { Button, Input, message } from "antd";
import { Job, OutputType, ProcessType, User } from "../JmReact";
import moment from "moment";


class SelectorZBranchList extends Component {

    constructor(props) {
        super(props);

        this.state = {
            modalZList: false,
            modalZListData: [],
            modalZListSearch: "",
            modalBranchFilter: null
        }
    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidMount() {
        if (this.props.isModalOnly && this.props.getZListOnOpen) {
            this.apiZList(this.props.getZListOnOpen)
        }
    }

    componentDidUpdate(prev) {
        if (this.props.isModalOnly && !prev.visible && this.props.visible) {
            this.onClick()
        }
    }

    apiZList = (next) => {
        this.sendAPI("get_z_branch_list", "", ob => {
            next(ob.data ? ob.data.split("\r").map(x => {
                let y = x.split("\f");
                return { num: y[0], branch: y[1], branchName: y[2], start: y[3], end: y[4] }
            }) : [])
        })
    }

    onBlurZInput = () => {
        const { zNumber } = this.props.filters;
        if (zNumber) {
            this.apiZList(list => {
                if (!list[0]) {
                    this.props.onChange({ zNumber: "" });
                    message.error(this.getText(19492))
                } else {
                    const { num, branch, start, end } = list[0];
                    this.props.onChange({ zNumber: num, branchList: branch, StartDate: start?.split(" ")[0], EndDate: end?.split(" ")[0] });
                }
            })
        }
    }

    sendAPI = (script, data, sCal) => {
        let user = new User(this.props.user.token, this.props.user.companyCode);
        let job = new Job(user, script, OutputType.OUTPUT_TYPE_DATA, ProcessType.PROCESS_TYPE_SYNC);
        job.setInput(data);
        job.send("/cgi-bin/CashOnTab", sCal, (e) => { console.error(e) });
    }

    onClick = () => {
        const { zNumber, branchId } = this.props.filters;
        this.apiZList(list => {
            this.setState({ modalZList: true, modalZListData: list, modalZListSearch: zNumber, modalBranchFilter: branchId })
        })
    }

    render() {
        const render = t => (<p style={{ textAlign: "right" }}>{t}</p>)
        const renderDatetime = t => (<p style={{ textAlign: "right", direction: "ltr" }}>{moment(t).format("DD/MM/YYYY HH:mm")}</p>)

        const renderModal = (<GenericModal
            visible={this.state.modalZList}
            onCancel={() => {
                this.setState({ modalZList: false }, this.onBlurZInput)
                if (this.props.onCancel) this.props.onCancel()
            }}
            title={this.getText(19493)}
            width={800}
            showsearch={() => { }}
            valueSearch={this.state.modalZListSearch}
            onChangeSearch={e => { this.setState({ modalZListSearch: e.target.value }) }}
        >
            <ResponsiveTable
                tableOnly
                dataSource={this.state.modalZListData
                    .filter(f => !this.state.modalZListSearch || f.num?.indexOf(this.state.modalZListSearch) > -1)
                    .filter(f => !this.state.modalBranchFilter || f.branch == this.state.modalBranchFilter)
                }
                columns={[
                    { title: this.getText(22073), key: "branch", dataIndex: "branch", render },
                    { title: this.getText(22074), key: "branchName", dataIndex: "branchName", render },
                    { title: this.getText(22075), key: "num", dataIndex: "num", render },
                    { title: this.getText(22076), key: "start", dataIndex: "start", render: renderDatetime },
                    { title: this.getText(22077), key: "end", dataIndex: "end", render: renderDatetime },
                    this.props.actionsColumn ??
                    {
                        render: (t, r) => (<Button type="primary" onClick={() => {
                            this.props.onChange({ zNumber: r.num, branchList: r.branch, StartDate: r.start?.split(" ")[0], EndDate: r.end?.split(" ")[0] });
                            this.setState({ modalZList: false })
                            if (this.props.onCancel) this.props.onCancel()
                        }}>{this.props.btnText ?? this.getText(19499)}</Button>)
                    },
                ]}
                pagination={{ pageSize: 10 }}
            />
        </GenericModal>)

        return this.props.isModalOnly ? renderModal
            : (<span>
                <Button type="primary" icon="unordered-list" onClick={this.onClick} />
                <Input
                    style={{ width: 300 }}
                    value={this.props.filters.zNumber}
                    onChange={(e) => {
                        if (e.target.value === "") this.props.onChange({ zNumber: "" })
                        if (parseInt(e.target.value)) this.props.onChange({ zNumber: parseInt(e.target.value) })
                    }}
                    onBlur={this.onBlurZInput}
                />
                {renderModal}
            </span>)
    }
}
export default SelectorZBranchList;